module.exports = __webpack_public_path__ + "static/media/1582748391650686428AVK01887.10e11689.jpg";